// employee-portal-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'emp.status.received': 'Mottatt',
  'emp.change.submitted': 'Sendt inn',
  'emp.change.resubmitted': 'Sendt inn på nytt',
  'emp.change.updated': 'Endret',
  'emp.change.withdrawn': 'Trukket tilbake',
  'emp.change.byEmployer': 'arbeidsgiver',
  'emp.change.byYou': 'deg',
  'emp.change.text': '{action} av {who}',
  'emp.employerFallback': 'Arbeidsgiver',
  'emp.employeeFallback': 'Ansatt',
  'emp.orgNumber': 'Org. {org}',
  'emp.accountingClient': 'Regnskapsklient',
  'emp.bg.default': 'Plomme',
  'emp.bg.mint': 'Mint',
  'emp.bg.varm': 'Varm',
  'emp.bg.sky': 'Bla',
  'emp.bg.rose': 'Rose',
  'emp.bg.skog': 'Skog',
  'emp.portalNotConnected': 'Ansattportal er ikke koblet til backend.',
  'emp.portalFetchFailed': 'Kunne ikke hente ansattportal.',
  'emp.attachReceipt': 'Legg ved kvittering',
  'emp.attachmentFallback': 'Bilag',
  'emp.expenseFillIn': 'Fyll ut kategori, beløp, beskrivelse og legg ved bilag.',
  'emp.voucherSentToBookkeeping': 'Bilaget er sendt til bokføring.',
  'emp.expenseSentForApproval': 'Utlegg sendt til godkjenning.',
  'emp.expenseSendFailed': 'Kunne ikke sende utlegg.',
  'emp.sending': 'Sender...',
  'emp.sendToBookkeeping': 'Send til bokføring',
  'emp.sendForApproval': 'Send til godkjenning',
  'emp.travelFillIn': 'Fyll ut formål, dato og reisemål.',
  'emp.lineExpenseRequired': 'Beskrivelse, beløp og bilag kreves.',
  'emp.attachmentUploadFailed': 'Kunne ikke laste opp bilag.',
  'emp.mileageFillIn': 'Fyll ut fra, til og kilometer.',
  'emp.accommodationFillIn': 'Legg inn beskrivelse av overnattingsstedet.',
  'emp.editMileage': 'Rediger kjøretur',
  'emp.newMileage': 'Ny kjøretur',
  'emp.editAccommodation': 'Rediger overnatting',
  'emp.newAccommodation': 'Ny overnatting',
  'emp.editExpense': 'Rediger utlegg',
  'emp.newExpense': 'Nytt utlegg',
  'emp.saving': 'Lagrer...',
  'emp.save': 'Lagre',
  'emp.add': 'Legg til',
  'emp.currency.NOK': 'Norske kroner',
  'emp.currency.EUR': 'Euro',
  'emp.currency.USD': 'Amerikanske dollar',
  'emp.currency.GBP': 'Britiske pund',
  'emp.currency.SEK': 'Svenske kroner',
  'emp.currency.DKK': 'Danske kroner',
  'emp.currency.CHF': 'Sveitsiske franc',
  'emp.currency.ISK': 'Islandske kroner',
  'emp.currency.PLN': 'Polske zloty',
  'emp.currency.AUD': 'Australske dollar',
  'emp.currency.CAD': 'Kanadiske dollar',
  'emp.draftSaved': 'Utkast lagret.',
  'emp.draftSaveFailed': 'Kunne ikke lagre utkast.',
  'emp.travelResubmitted': 'Reise sendt inn på nytt.',
  'emp.travelSentForApproval': 'Reise sendt til godkjenning.',
  'emp.travelSendFailed': 'Kunne ikke sende reise.',
  'emp.confirmWithdraw': 'Trekke reisen tilbake til utkast? Arbeidsgiver kan ikke behandle den før du sender den inn på nytt.',
  'emp.travelWithdrawn': 'Reisen er trukket tilbake og kan redigeres.',
  'emp.withdrawFailed': 'Kunne ikke trekke tilbake reisen.',
  'emp.confirmDeleteExpenseOfTravel': 'Slette utlegget? Dette fjerner den fra arbeidsgivers godkjenning også.',
  'emp.confirmDeleteTravel': 'Slette reisen? Dette fjerner den fra arbeidsgivers godkjenning også.',
  'emp.expenseDeleted': 'Utlegg slettet.',
  'emp.travelDeleted': 'Reise slettet.',
  'emp.deleteFailed': 'Kunne ikke slette.',
  'emp.editLine': 'Rediger linjen',
  'emp.withdrawing': 'Trekker tilbake...',
  'emp.withdraw': 'Trekk tilbake',
  'emp.close': 'Lukk',
  'emp.saveDraft': 'Lagre utkast',
  'emp.resubmit': 'Send inn på nytt',
  'emp.submitTravel': 'Send inn reise',
  'emp.fixAndResubmit': 'Rett opp reisen og send den inn på nytt.',
  'emp.changedAfterSubmit': 'Endret etter innsending',
  'emp.changedAfterSubmitText': 'Reisen er endret etter at du sendte den inn. Se historikken nederst.',
  'emp.addLinesToStart': 'Legg til kjøretur, utlegg eller opphold for å komme i gang.',
  'emp.dietCalculated': 'Diett beregnes',
  'emp.noDiet': 'Ingen diett (kun utlegg/kjøring)',
  'emp.noPayrollPayout': 'Denne reisen har ingen utlegg eller godtgjørelser som skal utbetales som lønn.',
  'emp.history': 'Historikk',
  'emp.totalCount': '{count} totalt',
  'emp.payrollRunFallback': 'Lønnskjøring',
  'emp.expenseFallback': 'Utlegg',
  'emp.voucherFetchFailed': 'Kunne ikke hente bilaget.',
  'emp.noPreviewLink': 'Fant ikke en visningslenke for bilaget.',
  'emp.confirmDeleteExpense': 'Slette utlegget? Dette fjerner det fra arbeidsgivers godkjenning også.',
  'emp.expenseDeleteFailed': 'Kunne ikke slette utlegget.',
  'emp.deleting': 'Sletter...',
  'emp.delete': 'Slett',
  'emp.noAttachmentFound': 'Ingen bilag funnet',
  'emp.tapToPreview': 'Trykk for å åpne forhåndsvisning.',
  'emp.noAttachmentName': 'Dette utlegget har ikke bilagsnavn i ansattportalen.',
  'emp.previewFetchFailed': 'Kunne ikke hente bilaget for forhåndsvisning.',
  'emp.travelFallback': 'Reise',
  'emp.connectingEmployers': 'Kobler til arbeidsgiverne dine.',
  'emp.noActiveAccess': 'Du har ingen aktive ansattportal-tilganger med denne e-posten.',
  'emp.payslipsAvailable': '{count} lønnsslipper tilgjengelig',
  'emp.noPayslipsReady': 'Ingen lønnsslipper er klare ennå.',
  'emp.pendingApprovedSummary': '{pending} til godkjenning - {approved} godkjent',
});
